<template>
  <div class="bad_tag_list">
    <ul v-if="edit">
      <li
        v-for="(item, index) in list"
        :key="index"
        :class="selArr.includes(item.tagId) && 'active'"
        @click="handleSelect(item)"
      >{{item.content}}</li>
    </ul>
    <ul v-else>
      <li
        v-for="(item, index) in list"
        :key="index"
      >{{item}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'EvaluateTags',
  props: {
    edit: {
      type: Boolean,
      default: true,
    },
    valueKey: {
      type: String,
      default: 'tagId'
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selArr: [],
    }
  },
  methods: {
    handleSelect(item) {
      const selId = item[this.valueKey]
      const index = this.selArr.indexOf(selId);
      if (index === -1) {
        this.selArr.push(selId)
      } else {
        this.selArr.splice(index, 1)
      }
      this.$emit('on-change-tags',this.selArr)
    }
  }
}
</script>

<style lang="scss" scoped>
.bad_tag_list {
  clear: both; 
  ul {
    display: flex;
    flex-wrap: wrap;
    li {
      margin-right: 10px;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      min-height: 32px;
      line-height: 20px;
      padding: 5px 30px;
      background: #f1f1f1;
      border-radius: 4px;
      color: #000;
      cursor: pointer;
      font-family: 'Aspira Light';
      font-weight: 200;
      &.active {
        background-color: #ffebe3;
        color: #FF7A45;;
        font-family: 'Aspira Medium'; // 如果变更字体，会导致文字抖动
        font-weight: 500;
      }
    }
  }
}

// 移动端适配
@media screen and (max-width: 768px) {
  .bad_tag_list {
    padding: 0 rem(32);
    ul {
      li {
        padding: rem(18) rem(50);
        font-size: rem(24);
      }
    }
    min-width: rem(650)
  }
}
</style>
